import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  async copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');
    if (!copyContent) return;

    try {
      await navigator.clipboard.writeText(copyContent);

      const copyButtonText = this.refs.copyButtonText;

      if (copyButtonText instanceof HTMLElement) {
        const originalText = copyButtonText.textContent;
        copyButtonText.textContent = 'Copied';

        clearTimeout(this._copyTimeout);
        this._copyTimeout = setTimeout(() => {
          copyButtonText.textContent = originalText || 'Copy';
        }, 1500);
      }
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}